module.exports = __webpack_public_path__ + "static/media/technology.23e0c6fd.svg";